import React from 'react';
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import GameButtonWithText from "../GameButtonWithText";
import GameData from "../../../gameplay/model/GameData";
import TrainCarRentBackCard from "./TrainCarRentBackCard";
import ConfirmPopup from "../Popups/ConfirmPopup";
import agent from "../../../agent";
import UtilsFunctions from "../../../utils/UtilsFunctions";
export default class TrainCarRentBackWindow extends React.Component {
    constructor() {
        super();
        this.state = {
            backInfo: {
                0 : 0,
                1 : 0,
                2 : 0,
                3 : 0
            },
            isShowConfirm: false
        }

        let clientsIndex = UtilsFunctions.getRoleNameIndex('Заместитель по тяге');
        this.rightRole = UtilsFunctions.playerHasRole(clientsIndex);
    }
    toggleConfirm() {
        this.setState({
            isShowConfirm: !this.state.isShowConfirm
        })
    }
    onSubmit(){
        agent.GamePlay.finishRentTrainCar(this.props.teamID, this.state.backInfo, (resp)=>{
            this.props.onHide();
        });
    }
    currentReturnSum(){
        let sum = 0;
        let gameData = GameData.CurrentGame;
        for (let i = 0; i < gameData.getStations().length; i++){
            sum += this.state.backInfo[i];
        }
        return sum;
    }
    calculateMax(forReturn, stationId){
        let max = forReturn;
        let gameData = GameData.CurrentGame;
        for (let i = 0; i < gameData.getStations().length; i++){
            if(i === stationId) continue;
            max -= this.state.backInfo[i];
        }
        return max;
    }
    calculateForReturn(){
        let count = 0;
        let gameData = GameData.CurrentGame;
        for (let i = 0; i < gameData.rentTrainCarContract.length; i++){
            let contract = gameData.rentTrainCarContract[i];
            if(!contract.isCompleted && contract.startDay + contract.days <= gameData.day + gameData.year * 4){
                count += contract.count;
            }
        }
        return count;
    }
    onCardValueChange(station, count){
        let backInfo = this.state.backInfo;
        backInfo[station.id] = count;
        this.setState({
            backInfo: backInfo
        });
    }
    render() {
        if(!this.props.isShow || !this.rightRole){
            return null;
        }
        let forReturn = this.calculateForReturn();
        let moveStyle = {
            position: "absolute",
            left: this.props.width / 2,
            top: this.props.height / 2,
            transform: window.innerWidth > 1500 ? "translate(-50%,-50%)" : "translate(-50%, -54%) scale(0.78)"
        }
        let textStyle = {
            fontSize: 32,
            textTransform: "uppercase"
        };
        let stations = GameData.CurrentGame.getStations();
        let stationCards = [];
        for (let i = 0; i < stations.length; i++){
            let station = stations[i];
            stationCards.push(<TrainCarRentBackCard
                key={i}
                station={station}
                value={ this.state.backInfo[station.id]}
                max={this.calculateMax(forReturn, station.id)}
                onValueChange={this.onCardValueChange.bind(this)} />)
        }
        let confirmPopup = <ConfirmPopup
            message={"Если вы нажмете подтвердить, то больше не сможете изменить свой выбор. Продолжить?"}
            title={"Завершение инвестиций"}
            onOk={this.onSubmit.bind(this)}
            onCancel={this.toggleConfirm.bind(this)}
        />
        let content = [];
        content.push(<div key={"content"} style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: 60
        }}><div style={textStyle}><b>необходимо вернуть</b></div><div style={{...textStyle,
            marginLeft: 20,
            marginRight: 20,
            background: "#F2F2F2"
        }}><b>{forReturn - this.currentReturnSum()}</b></div><div style={textStyle}><b>вагонов.</b></div></div>)
        content.push(<div key={'message'} style={{...textStyle,
        paddingBottom: 60}}>
            <b>
                Выберите, сколько вагонов со станции вы хотите вернуть.<br />
                Если вы вернете не все арендованные вагоны - штраф 50 000 руб. за каждый вагон.
            </b>

        </div>)
        content.push(<div key={"cards"} style={{
            display: "flex",
            justifyContent: "space-between",
            padding: 20,
            paddingBottom: 60
        }}>
            {stationCards}
        </div>)
        content.push(<GameButtonWithText key={'confirm'} title={"Подтвердить"} width={375} height={60} fontSize={21} disabled={!this.rightRole}
                                                  onClick={this.toggleConfirm.bind(this)}/>)
        return <div className="in-game-popup" style={{
            width: this.props.width,
            height: this.props.height,
            background: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)"}}>
            <div style={moveStyle}>
                <GameWindowHeader title="возврат вагонов" onHide={this.props.onHide}
                                  width={1700} height={40} fontSize={20}/>
                <GameWindowBg width={1700} height={600} value={content}/>

            </div>
            {this.state.isShowConfirm && confirmPopup}
        </div>
    }
}
